/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Pause_Reasons_PermissionsInputs */

const en_tables_pause_reasons_permissions = /** @type {(inputs: Tables_Pause_Reasons_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reasons Permissions`)
};

const de_tables_pause_reasons_permissions = /** @type {(inputs: Tables_Pause_Reasons_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechtigungen`)
};

/**
* | output |
* | --- |
* | "Reasons Permissions" |
*
* @param {Tables_Pause_Reasons_PermissionsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_pause_reasons_permissions = /** @type {((inputs?: Tables_Pause_Reasons_PermissionsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Pause_Reasons_PermissionsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_pause_reasons_permissions(inputs)
	return de_tables_pause_reasons_permissions(inputs)
});